<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { form, field } from "svelte-forms";
	import { navigate } from "svelte-routing";
	import { loading, vehicleEditData } from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idColor = window.location.pathname.split(
		"master-data/vehicle-data/vehicle-color/edit/"
	)[1];

	let carColorError;
	const carColor = field("carColor", $vehicleEditData.name, [required()]);
	const myForm = form(carColor);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/colors", {
				method: "PUT",
				version: "Vehicle",
				data: {
					name: $carColor.value,
					id: idColor,
				},
			});

			if (res?.status === 200) {
				navigate("/master-data/vehicle-data/vehicle-color");
			} else {
				loading.set(false);
				carColorError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			carColorError = error.response.data.message;
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Color Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Vehicle Color</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span> Vehicle Color* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carColor.value}
						error={$myForm.hasError("carColor.required") ||
							carColorError}
						errorText={$myForm.hasError("carColor.required")
							? "Vehicle color is required"
							: carColorError
								? carColorError
								: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carColor.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Edit
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
